import { company } from '~/company/Company';
import type { Offer, Product } from '~/stores/CategoriesStore';

/**
 * Hardcoded commodity group IDs that require age verification on the frontend.
 * IDs match backend taxonomy: 2 = Tobacco, 3 = Alcohol.
 * Used as a fallback when the backend does not provide the per-product
 * `properties.age_restriction` flag (e.g. CircleK).
 */
export const RESTRICTED_COMMODITY_GROUP_IDS: readonly number[] = [2, 3];

/**
 * Detects whether a cart/catalog item must trigger the age-restriction modal
 * before being added to the cart.
 *
 * Logic (OR):
 * 1. Per-product flag `properties.age_restriction === true` (backend-driven,
 *    used by Localee/CityDrinks/etc.)
 * 2. When `company.useCommodityGroupAgeCheck` is on AND the item belongs to
 *    a hardcoded restricted commodity group (Tobacco/Alcohol).
 */
export const isItemAgeRestricted = (item: Offer | Product): boolean => {
  if (item.properties.age_restriction) {
    return true;
  }

  if (!company.useCommodityGroupAgeCheck) {
    return false;
  }

  const groupId = item.commodityGroup?.id;
  return (
    groupId !== undefined && RESTRICTED_COMMODITY_GROUP_IDS.includes(groupId)
  );
};
